import type { HomeInstitutionEventDto } from '@generated/unauth';

import { DONATION_ROUTES, ROUTES, WEBVIEW_TYPE_ENTRY } from '@/constants';
import { getStaticCdnUrl } from '@/utils';
import { checkTodayInRange } from '@/utils/checkTodayInRange';

import { CARD_PROMOTIONS } from '../../_constants/cardEventBanners';

type MainBannerItem = {
  title: string;
  imageUrl: string;
  href: string;
  target?: string;
  eventId?: HomeInstitutionEventDto['eventId'];
};

export const filterMainBannerItems = (
  data: HomeInstitutionEventDto[],
  entry: string,
) => {
  const mainBannerItems: MainBannerItem[] =
    data
      ?.filter((item) => item && item.title)
      .map((item) => ({
        title: item.title,
        imageUrl: item.thumbnailUrl,
        href: DONATION_ROUTES.MY_ETC_EVENT_DETAIL.pathname({
          eventId: item.eventId,
        }),
        eventId: item.eventId,
      })) ?? [];

  const cardPromotions: MainBannerItem[] =
    entry === 'WELLO' ? [...CARD_PROMOTIONS.main] : [];

  const localMarketItem: MainBannerItem | null =
    entry === WEBVIEW_TYPE_ENTRY.WELLO
      ? {
          href: '/welmarket',
          title: '웰마켙 오픈',
          imageUrl:
            'https://cdn.welfarehello.com/static/local-market/home/hero-banner-pc-bg-1.png',
        }
      : null;

  const upgradeItem: MainBannerItem | null =
    entry !== WEBVIEW_TYPE_ENTRY.TOSS
      ? {
          href: '/community/policyInfo/1ea2bcd4-0705-4f32-a403-37fb3cae8910',
          title: '2026년 고향사랑기부제 공제율 최대 44% 확대',
          imageUrl:
            'https://cdn.welfarehello.com/static/banner/donation-upgrade.png',
        }
      : null;

  const floodReliefItem: MainBannerItem | null = checkTodayInRange(
    '2026-08-18T00:00:00+09:00',
    '2026-09-30T23:59:59+09:00',
  )
    ? {
        //* 토스에는 통합 콘텐츠 상세를 열지 않아 그쪽만 지정기부 목록으로 보낸다.
        href:
          entry === WEBVIEW_TYPE_ENTRY.TOSS
            ? DONATION_ROUTES.HOMETOWNS_BUSINESS.pathname
            : ROUTES.POLICY_INFO_DETAIL.pathname({
                idIdx:
                  '%EC%82%AC%ED%9D%98-%EB%8F%99%EC%95%88-910-%EB%82%A8%ED%95%B4%EC%95%88%EC%97%90-%EB%AC%B4%EC%8A%A8-%EC%9D%BC%EC%9D%B4-%EC%9E%88%EC%97%88%EB%82%98--adf65d24-9204-4dd0-85ca-90a28e2904b5',
              }),
        title: '거제·통영 집중호우 피해 복구 지정기부',
        imageUrl: getStaticCdnUrl(
          'banner/donation-geoje-tongyeong-flood-2608.png',
        ),
      }
    : null;

  const sortedMainBannerItems: MainBannerItem[] = [
    floodReliefItem,
    localMarketItem,
    ...cardPromotions,
    upgradeItem,
    ...mainBannerItems,
    {
      href: 'https://blink.do/Wello',
      title: '연말정산 보험 환급액 확인하기',
      imageUrl: 'https://cdn.welfarehello.com/static/banner/signal.png',
    },
  ].filter(
    (item): item is NonNullable<typeof item> =>
      item !== null && item !== undefined,
  );

  return sortedMainBannerItems;
};
